var _excluded = ["node"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import Highlight, { defaultProps } from 'prism-react-renderer';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
export default function Markdown(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ReactMarkdown, {
    rehypePlugins: [rehypeSanitize],
    components: {
      pre: function pre(_ref2) {
        var _children$, _children$$props;

        var children = _ref2.children;
        return /*#__PURE__*/React.createElement(Highlight, _extends({}, defaultProps, {
          code: (_children$ = children[0]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : _children$$props.children[0],
          language: "js"
        }), function (_ref3) {
          var className = _ref3.className,
              style = _ref3.style,
              tokens = _ref3.tokens,
              getLineProps = _ref3.getLineProps,
              getTokenProps = _ref3.getTokenProps;
          return /*#__PURE__*/React.createElement("pre", {
            className: className,
            style: style
          }, tokens.map(function (line, i) {
            return /*#__PURE__*/React.createElement("div", getLineProps({
              line: line,
              key: i
            }), line.map(function (token, key) {
              return /*#__PURE__*/React.createElement("span", getTokenProps({
                token: token,
                key: key
              }));
            }));
          }));
        });
      },
      a: function a(_ref4) {
        var node = _ref4.node,
            props = _objectWithoutPropertiesLoose(_ref4, _excluded);

        return /*#__PURE__*/React.createElement("a", _extends({
          rel: "nofollow"
        }, props));
      }
    },
    className: "squeak-post-markdown"
  }, children);
}